import { queryOptions, useQuery } from '@tanstack/react-query'

import { getGisEntities } from '../api/gisApi'

/**
 * Entity list for the dashboard entity filter. Entities change rarely, so a 15-minute staleTime
 * keeps the picker populated without refetching on every navigation.
 */
export const gisEntitiesQueryOptions = () =>
  queryOptions({
    queryKey: ['gis', 'entities'] as const,
    queryFn: () => getGisEntities(),
    staleTime: 1000 * 60 * 15,
  })

export function useGisEntities() {
  return useQuery(gisEntitiesQueryOptions())
}
